import { portalApi } from './portalApi';

// All North Prairie entry points share the same short-lived initial snapshot.
// Explicit saves and realtime invalidations still request fresh server data.
export const readNpSnapshot = (url, { force = false } = {}) => (dispatch, getState) => {
  const state = getState();
  return dispatch(portalApi.endpoints.getNpSnapshot.initiate({
    url,
    accountId: state.user?.userDetails?.localAccountId || state.user?.userDetails?.username || '',
    session: state.criticalData?.session || 0,
  }, { subscribe: false, forceRefetch: force ? true : 30 }));
};
